import angular from "angular";

export default function XucDirectory($rootScope, XucPhoneHintService, XucLink, $log, $q, XucVideoEventManager, Broadcaster) {
  var searchResult = [];
  var contactSheet = [];
  var favoriteContactSheet = [];
  var favorites = [];
  var headers = [];
  var searchTerm = null;
  var isSearching = false;
  var displayNameRequests = new Map();
  var displayNamesCache = new Map();

  var _directoryLookup = function(term) {
    searchTerm = term ? term : '';
    isSearching = true;
    Cti.directoryLookUp(searchTerm);
  };

  var _getSearchTerm = function() {
    return searchTerm;
  };

  var _isSearching = function() {
    return isSearching;
  };

  var _onSearchResult = function(result) {
    searchResult = angular.copy(result.entries);
    isSearching = false;
    _setHeaders(result);
    $rootScope.$broadcast('searchResultUpdated');
  };

  var _onContactSheet = function(result) {
    contactSheet = angular.copy(result.sheets);
    isSearching = false;
    $rootScope.$broadcast('contactSheetUpdated');
  };

  var _onFavoriteContactSheet = function(result) {
    favoriteContactSheet = angular.copy(result.sheets);
    isSearching = false;
    $rootScope.$broadcast('favoriteContactSheetUpdated');
  };

  var _onFavorites = function(newFavorites) {
    searchResult = [];
    favorites = angular.copy(newFavorites.entries);
    _setHeaders(newFavorites);
    $rootScope.$broadcast('favoritesUpdated');
  };

  var _onUserDisplayNameResult = function(result) {
    if (result.displayName) {
      if (displayNameRequests.has(result.userName)) {
        displayNamesCache.set(result.userName, result.displayName);
        displayNameRequests.get(result.userName).resolve(result.displayName);
        displayNameRequests.delete(result.userName);
      }
      else {
        $log.error("Unknown result received, no such username in the map", result.userName);
      }
    }
    else {
      $log.error("Error when retrieving display name ", result);
      displayNameRequests.forEach((values) => {
        values.reject('Failure');
      });
      displayNameRequests.clear();
    }
  };

  var _setHeaders = function(result) {
    headers = angular.copy(result.headers);
    if(headers.indexOf("Favoris") != -1) {
      headers.splice(-3, 2);
    }
  };

  var _onFavoriteUpdated = function(update) {
    if (update.action === "Removed" || update.action === "Added") {
      contactSheet.forEach(function (elem) {
        if (elem.sources[0].id === update.contact_id && elem.sources[0].name === update.source) {
          elem.isFavorite = ! elem.isFavorite;
        }
      });
    }
    else {
      $log.log("SERVER ERROR: Favorite update failed: ", update);
    }
    _updateFavorites(update);
    $rootScope.$broadcast('searchResultUpdated');
  };

  var _updateFavorites = function(update) {
    if (update.action === "Removed") {
      var result = _find(favoriteContactSheet, update);
      result.elem.isFavorite = false;
      if (_find(contactSheet, update) === undefined) contactSheet.push(result.elem);
      if (result.index >= 0) favoriteContactSheet.splice(result.index, 1);
    }
    else if (update.action == "Added") {
      var newFavorite = _find(contactSheet, update);
      if (newFavorite) {
        newFavorite.elem.isFavorite = true;
        favoriteContactSheet.push(newFavorite.elem);
      }
    }
    $rootScope.$broadcast('favoritesUpdated');
    $rootScope.$broadcast('favoriteContactSheetUpdated');
  };

  var _find = function(contacts, update) {
    var result;
    contacts.forEach(function(elem, i) {
      if (elem.sources[0].id === update.contact_id && elem.sources[0].name === update.source) {
        result = {'elem': elem, 'index': i};
      }
    });
    return result;
  };

  var _getSearchResult = function() {
    return searchResult;
  };

  var _getContactSheetResult = function() {
    return contactSheet;
  };

  var _getFavoriteContactSheet = function() {
    return favoriteContactSheet;
  };

  var _getFavorites = function() {
    return favorites;
  };

  var _clearResults = function() {
    favorites = [];
    searchResult = [];
    searchTerm = null;
    isSearching = false;
    $rootScope.$broadcast('searchResultUpdated');
  };

  var _getHeaders = function() {
    return headers;
  };

  let _updatePhoneHintStatus = (list, phoneHint, sourceEvent) => {
    list.forEach( contact => {
      if (contact.actions['Call'] && !isEmpty(contact.actions['Call'].args) && contact.actions['Call'].args[0] === phoneHint.number) {
        contact.status.phone = phoneHint.status;
        Broadcaster.send(sourceEvent);
      }
    });
  };

  let _onPhoneHint = function(phoneHint) {
    if (!isEmpty(contactSheet)) {
      _updatePhoneHintStatus(contactSheet, phoneHint, 'searchResultUpdated');
    } 
    if(!isEmpty(favoriteContactSheet)) {
      _updatePhoneHintStatus(favoriteContactSheet, phoneHint, 'favoritesUpdated');
    }
  };

  var isEmpty = function(array) {
    return array.length == 0;
  };

  let _updateVideoEventStatus = (list, videoEvent, sourceEvent) => {
    list.forEach( contact => {
      if (contact.actions['Video'] && !isEmpty(contact.actions['Video'].args) &&  contact.actions['Video'].args[0] === videoEvent.fromUser) {
        contact.status.video = videoEvent.status;
        Broadcaster.send(sourceEvent);
      }
    });
  };

  let _onVideoEvent = function(videoEvent) {

    if (!isEmpty(contactSheet)) {
      _updateVideoEventStatus(contactSheet, videoEvent, 'searchResultUpdated');
    }
    if(!isEmpty(favoriteContactSheet)) {
      _updateVideoEventStatus(favoriteContactSheet, videoEvent, 'favoritesUpdated');
    }
  }; 

  var _getUserDisplayName = (user) => {
    var deferred = $q.defer();
    if (displayNamesCache.has(user)) {
      deferred.resolve(displayNamesCache.get(user));
    }
    else
    {
      displayNameRequests.set(user, deferred);
      Cti.displayNameLookup(user);
    }
    return deferred.promise;
  };

  XucPhoneHintService.addEventListener($rootScope, _onPhoneHint);
  XucVideoEventManager.subscribeToVideoStatusEvent($rootScope,_onVideoEvent);

  const _init = () => {
    $log.info("Starting XucDirectory service");
    Cti.setHandler(Cti.MessageType.DIRECTORYRESULT, _onSearchResult);
    Cti.setHandler(Cti.MessageType.CONTACTSHEET, _onContactSheet);
    Cti.setHandler(Cti.MessageType.FAVORITECONTACTSHEET, _onFavoriteContactSheet);
    Cti.setHandler(Cti.MessageType.FAVORITES, _onFavorites);
    Cti.setHandler(Cti.MessageType.FAVORITEUPDATED, _onFavoriteUpdated);
    Cti.setHandler(Cti.MessageType.USERDISPLAYNAME, _onUserDisplayNameResult);
    XucLink.whenLoggedOut().then(_unInit);
  };

  const _unInit = () => {
    $log.info("Unloading XucDirectory service");
    displayNameRequests.clear();
    displayNamesCache.clear();
    XucLink.whenLogged().then(_init);
  };

  XucLink.whenLogged().then(_init);

  return {
    directoryLookup: _directoryLookup,
    onSearchResult : _onSearchResult,
    onContactSheet : _onContactSheet,
    onFavoriteContactSheet : _onFavoriteContactSheet,
    onFavorites : _onFavorites,
    onFavoriteUpdated : _onFavoriteUpdated,
    getSearchResult : _getSearchResult,
    getContactSheetResult : _getContactSheetResult,
    getFavorites : _getFavorites,
    clearResults: _clearResults,
    getHeaders : _getHeaders,
    getSearchTerm : _getSearchTerm,
    getFavoriteContactSheet : _getFavoriteContactSheet,
    isSearching : _isSearching,
    getUserDisplayName: _getUserDisplayName,
  };
}
